export const difficultyModalActionTypes = {
	TOGGLE_DIFFICULTY_MODAL: 'TOGGLE_DIFFICULTY_MODAL',
} as const;
